import { nonNullable } from 'lib/array/arrayUtils'
import { mergeOccupants } from 'lib/offer/occupancyUtils'

export function sumOccupancies(
  occupancies: Array<App.Occupants | undefined>,
): App.Occupants | undefined {
  const validOccupancies = nonNullable(occupancies)

  if (validOccupancies.length === 0) {
    return undefined
  }

  return mergeOccupants(validOccupancies)
}
